/** @jsx jsx */
import { jsx } from '@emotion/react';

import type * as React from 'react';

import { useQuery } from '@apollo/client';

import RelatedSkillsContext from 'bundles/browse-common/contexts/RelatedSkillsContext';
import DomainRelatedSkillsQuery from 'bundles/browse-common/queries/DomainRelatedSkillsQuery.graphql';
import type {
  DomainRelatedSkillsQuery as DomainRelatedSkillsQueryType,
  DomainRelatedSkillsQueryVariables,
} from 'bundles/browse-common/queries/__generated__/DomainRelatedSkillsQuery';
import { type Skill } from 'bundles/browse-common/types/Skill';

type Props = {
  skill: Skill;
  children: React.ReactNode;
};

function useRelatedSkillsQuery(parentSkillId: string) {
  return useQuery<DomainRelatedSkillsQueryType, DomainRelatedSkillsQueryVariables>(DomainRelatedSkillsQuery, {
    variables: {
      request: {
        parentSkillIds: [parentSkillId],
        includeOnlyEligibleForScoring: false,
        minimumNumberOfRecs: 0,
        granularities: [3],
        skillSorts: ['GRANULARITY_ASC'],
      },
      limit: 20,
    },
    context: {
      clientName: 'gatewayGql',
    },
    errorPolicy: 'all',
  });
}

const RelatedChildSkillsProvider = (props: Props) => {
  const { children, skill } = props;

  const { data } = useRelatedSkillsQuery(skill.id);

  const skills = data?.Skills?.querySkills.elements;

  return <RelatedSkillsContext.Provider value={{ skills }}>{children}</RelatedSkillsContext.Provider>;
};

export default RelatedChildSkillsProvider;
